import { EmailOnlyModal } from 'components/authentication_modals/EmailOnlyModal'
import SignInModal from 'components/authentication_modals/SignInModal'
import SignUpModal from 'components/authentication_modals/SignUpModal'
import { mount } from 'packs/config/react_rails'

/**
 * Table of all the components needed in this pack. To add a component, put the string you pass into
 * `react-rails` on the left hand side, and a `require` statement for the component on the right.
 */
const components = {
  'authentication_modals/EmailOnlyModal': EmailOnlyModal,
  'authentication_modals/SignInModal': SignInModal,
  'authentication_modals/SignUpModal': SignUpModal
}

mount(components)
